// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RanaFile } from "./RanaFile";
import {
  RanaFileFromJSON,
  RanaFileFromJSONTyped,
  RanaFileToJSON,
  RanaFileToJSONTyped,
} from "./RanaFile";

/**
 *
 * @export
 * @interface CalculateFloorLevelOutput
 */
export interface CalculateFloorLevelOutput {
  /**
   *
   */
  buildings: RanaFile;
}

/**
 * Check if a given object implements the CalculateFloorLevelOutput interface.
 */
export function instanceOfCalculateFloorLevelOutput(
  value: object
): value is CalculateFloorLevelOutput {
  if (!("buildings" in value) || value["buildings"] === undefined) return false;
  return true;
}

export function CalculateFloorLevelOutputFromJSON(json: any): CalculateFloorLevelOutput {
  return CalculateFloorLevelOutputFromJSONTyped(json, false);
}

export function CalculateFloorLevelOutputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CalculateFloorLevelOutput {
  if (json == null) {
    return json;
  }
  return {
    buildings: RanaFileFromJSON(json["buildings"]),
  };
}

export function CalculateFloorLevelOutputToJSON(json: any): CalculateFloorLevelOutput {
  return CalculateFloorLevelOutputToJSONTyped(json, false);
}

export function CalculateFloorLevelOutputToJSONTyped(
  value?: CalculateFloorLevelOutput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    buildings: RanaFileToJSON(value["buildings"]),
  };
}
